import React from 'react'

const NotFound = () => (
  <>
    Oops we couldn't find this section...
  </>
)

export default NotFound